import React from "react";

const WhatsAppIcon = ({
  size = 13,
  color = "white",
  className = "",
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M10.3906 1.80469C11.5391 2.95312 12.25 4.45703 12.25 6.09766C12.25 9.43359 9.46094 12.168 6.09766 12.168C5.08594 12.168 4.10156 11.8945 3.19922 11.4297L0 12.25L0.847656 9.10547C0.328125 8.20312 0.0273438 7.16406 0.0273438 6.07031C0.0273438 2.73438 2.76172 0 6.09766 0C7.73828 0 9.26953 0.65625 10.3906 1.80469ZM6.09766 11.1289C8.88672 11.1289 11.2109 8.85938 11.2109 6.09766C11.2109 4.73047 10.6367 3.47266 9.67969 2.51562C8.72266 1.55859 7.46484 1.03906 6.125 1.03906C3.33594 1.03906 1.06641 3.30859 1.06641 6.07031C1.06641 7.02734 1.33984 7.95703 1.83203 8.77734L1.96875 8.96875L1.44922 10.8281L3.36328 10.3086L3.52734 10.418C4.32031 10.8828 5.19531 11.1289 6.09766 11.1289ZM8.88672 7.35547C9.02344 7.4375 9.13281 7.46484 9.16016 7.54688C9.21484 7.60156 9.21484 7.90234 9.07812 8.25781C8.94141 8.61328 8.33984 8.94141 8.06641 8.96875C7.57422 9.05078 7.19141 9.02344 6.23438 8.58594C4.70312 7.92969 3.71875 6.39844 3.63672 6.31641C3.55469 6.20703 3.03516 5.49609 3.03516 4.73047C3.03516 3.99219 3.41797 3.63672 3.55469 3.47266C3.69141 3.30859 3.85547 3.28125 3.96484 3.28125C4.04688 3.28125 4.15625 3.28125 4.23828 3.28125C4.34766 3.28125 4.45703 3.25391 4.59375 3.55469C4.70312 3.85547 5.03125 4.59375 5.05859 4.67578C5.08594 4.75781 5.11328 4.83984 5.05859 4.94922C4.78516 5.52344 4.45703 5.49609 4.62109 5.76953C5.22266 6.78125 5.79688 7.13672 6.69922 7.57422C6.83594 7.65625 6.91797 7.62891 7.02734 7.54688C7.10938 7.4375 7.41016 7.08203 7.49219 6.94531C7.60156 6.78125 7.71094 6.80859 7.84766 6.86328C7.98438 6.91797 8.72266 7.27344 8.88672 7.35547Z"
        fill={color}
      />
    </svg>
  );
};

export default WhatsAppIcon;